import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useMediaQuery } from 'react-responsive';

import { breakpointDown } from '../../../../services/responsive/responsive';

const propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

const Footer = ({ children, className }) => {
  const mobile = useMediaQuery(breakpointDown('md'));

  const classes = classNames({
    'pro-wrapper-footer': true,
    'd-none': mobile,
    [className]: !!className,
  });

  return (
    <div className={classes}>
      <div className="pro-wrapper-footer-wrap">{children}</div>
    </div>
  );
};

Footer.propTypes = propTypes;

export default Footer;
